import $ from 'jquery';

export default function reviewProductModule() {
  const reviewProductElement = $('#review-product-form');
  if (reviewProductElement.length) {
    return import(/* webpackChunkName: "reviewProduct" */ '../reviewProduct')
      .then(({ default: ReviewProduct }) => {
        const reviewProduct = new ReviewProduct();
        return reviewProduct;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
